import React from 'react';
import tw from 'twin.macro';
import styled from '@emotion/styled';
import { SortableTreeItem } from 'components/Tree2/SortableTreeItem';
import { ITreeNode, TreeEventHandler } from './types';

interface Props<T> {
  draggingItem?: ITreeNode<T>;
  nodes?: Array<ITreeNode<T>>;
  onNodeClick: TreeEventHandler<T>;
  onNodeCollapse?: TreeEventHandler<T>;
  onNodeExpand?: TreeEventHandler<T>;
  path?: number[];
  RenderLabelComponent?: React.ComponentType<{
    className?: string;
    node: ITreeNode<T>;
  }>;
}

const StyledTree = styled.div`
  .enter {
    ${tw`transition duration-100 ease-out`}
  }

  .enterFrom {
    ${tw`transform opacity-0`}
  }

  .enterTo {
    ${tw`transform opacity-100`}
  }

  .leave {
    ${tw`transition duration-75 ease-out`}
  }

  .leaveFrom {
    ${tw`transform opacity-100`}
  }

  .leaveTo {
    ${tw`transform opacity-0`}
  }
`;

export function Tree2<T>(props: Props<T>) {
  const {
    nodes = [],
    onNodeClick,
    onNodeCollapse,
    onNodeExpand,
    path = [],
    draggingItem,
    RenderLabelComponent,
  } = props;
  return (
    <StyledTree tw="text-neutral-intense">
      {nodes.map((node, index) => {
        if (!node?.id) {
          return null;
        }
        return (
          <SortableTreeItem
            key={node.id}
            id={node.id}
            node={node}
            index={index}
            onNodeClick={onNodeClick}
            onNodeCollapse={onNodeCollapse}
            isPlaceholder={node.isPlaceholder}
            onNodeExpand={onNodeExpand}
            draggingItem={draggingItem}
            path={path}
            RenderLabelComponent={RenderLabelComponent}
          />
        );
      })}
    </StyledTree>
  );
}
